import { useQuery, UseQueryOptions } from '@tanstack/react-query';

import { getOrgMember } from '@/features/auth/api/get-org-member';
import { useUser } from '@/features/auth/hooks/use-user';
import { User } from '@/features/auth/types/user';
import { useCurrentOrg } from '@/features/org/hooks/use-org';

export type OrgUser = User & { role: string };

type Props = UseQueryOptions<OrgUser | null, unknown, OrgUser>;

export const useOrgUser = (props?: Props) => {
  const { data: user } = useUser();
  const { data: org } = useCurrentOrg();

  return useQuery({
    ...props,
    queryKey: ['orgUser', org?.id],
    queryFn: async () => {
      if (!org || !user) {
        return null;
      }

      const orgUserData = await getOrgMember(org.id, user.id);
      return { ...user, role: orgUserData.role };
    },
    enabled: !!org && !!user,
  });
};
